import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import * as React from 'react';
import { TransitionGroup } from '../TransitionGroup/';
import styled from 'styled-components';
import { WaterDrop } from './WaterDrop';
import { propTypes, initialState } from './TouchRipple.types';
export var DELAY_RIPPLE = 80;
var Container = styled.span.withConfig({
  displayName: "TouchRipple__Container",
  componentId: "sc-48lt14-0"
})(["display:block;position:absolute;overflow:hidden;border-radius:inherit;width:100%;height:100%;left:0;top:0;pointer-events:none;z-index:0;color:currentColor;"]);

var TouchRipple =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TouchRipple, _React$PureComponent);

  function TouchRipple() {
    var _this;

    _classCallCheck(this, TouchRipple);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TouchRipple).apply(this, arguments));
    _this.state = initialState; // Used to filter out mouse emulated events on mobile.

    _this.ignoringMouseDown = false; // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.

    _this.startTimer = null; // This is the hook called once the previous timeout is ready.

    _this.startTimerCommit = null;
    _this.touchRippleRef = null;

    _this.pulsate = function () {
      _this.start({}, {
        pulsate: true
      });
    };

    _this.onTouchRippleRef = function (node) {
      _this.touchRippleRef = node;
    };

    _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === void 0 ? true : _options$pulsate,
          _options$center = options.center,
          center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center;

      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var element = _this.touchRippleRef;
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }; // Get the size of the ripple

      var rippleX;
      var rippleY;
      var rippleSize;

      if (center || event.clientX === 0 && event.clientX === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      } // Touch devices


      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Deplay the execution of the ripple effect.


        _this.startTimer = setTimeout(function () {
          _this.startTimerCommit();

          _this.startTimerCommit = null;
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize,
          cb: cb
        });
      }
    };

    _this.startCommit = function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;
      var _this$props = _this.props,
          duration = _this$props.duration,
          color = _this$props.color;
      var ripples = _this.state.ripples; // Add a ripple to the ripples array.

      ripples = _toConsumableArray(ripples).concat([React.createElement(WaterDrop, {
        key: _this.state.nextKey,
        timeout: {
          exit: duration,
          enter: duration
        },
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        duration: duration,
        color: color
      })]);

      _this.setState({
        nextKey: _this.state.nextKey + 1,
        ripples: ripples
      }, cb);
    };

    _this.stop = function (event, cb) {
      // return { event, cb };
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples; // The touch interaction occures to quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();

        _this.startTimerCommit();

        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        }, 0);
        return;
      }

      _this.startTimerCommit = null;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    };

    return _this;
  }

  _createClass(TouchRipple, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var other = {
        innerRef: this.onTouchRippleRef
      };
      return React.createElement(TransitionGroup, _extends({
        component: Container,
        enter: true,
        exit: true
      }, this.props, other), this.state.ripples);
    }
  }]);

  return TouchRipple;
}(React.PureComponent);

TouchRipple.propTypes = propTypes;
export { TouchRipple };